import { headerJs } from "./header";
import { lenis } from "./plugins/initLenis";

// document.addEventListener("DOMContentLoaded", function () {
headerJs()
const buttons = document.querySelectorAll(".openVideoModal");
const closeButtons = document.querySelectorAll(".closeIframe")
let player;
let playerContainer

buttons.forEach(button => {
    button.addEventListener("click", function () {
        const videoId = this.dataset.videoid
        const container = this.closest(".dialog-container");
        const dialog = container.querySelector("dialog");
        const videoContainer = dialog.querySelector('.videoContainer')
        const newDiv = document.createElement("div");
        newDiv.classList.add('player')
        videoContainer.append(newDiv)
        playerContainer = videoContainer
        const videoPlaceholder = videoContainer.querySelector(".player")
        dialog.showModal();
        lenis.stop()
        player = new YT.Player(videoPlaceholder, {
            height: '390',
            width: '640',
            videoId: videoId,
            playerVars: {
                'playsinline': 1
            },
        });
    });



});

const dialogs = document.querySelectorAll("dialog");
dialogs.forEach(dialog => {
    dialog.addEventListener("close", () => {
        dialog.close();
        lenis.start()
    });
});
closeButtons.forEach(button => {
    button.addEventListener("click", () => {
        playerContainer.innerHTML = "";
        const dialog = button.closest("dialog")
        // player.stopVideo();
        dialog.close();
    });
});
// });
